import '@features/cluster/model/cluster.epics'
import '@features/plan-list/model/plan-list.epics'
import '@features/profile/model/profile.epics'
import '@features/session/model/session.epics'
import '@features/users/model/store/users.epics'
import '@pages/main-page/main-page.epics'
import { ReactNode } from 'react'
import { Provider } from 'react-redux'
import { store } from '@shared/lib/redux'
import '@shared/lib/router/model/router.epic'

export const StoreProvider = ({ children }: { children: ReactNode }) => {
  return <Provider store={store}>{children}</Provider>
}
